<div class="task-container" #rootContainer>
  <!-- Toggle Header -->
  <div class="toggle-header">
    <button class="toggle-btn" [ngClass]="{'active': showTable}" (click)="showTable = true">
      {{ 'TASK.TASKS_LIST' | translate }}
    </button>
    <button class="toggle-btn" [ngClass]="{'active': !showTable}" (click)="showTable = false"
      [disabled]="showApprovalForm || showLogViewer">
      {{ 'TASK.CREATE_TASK' | translate }}
    </button>
  </div>

  <!-- Tasks Table -->
  <div class="tasks-table-content" *ngIf="showTable && !showApprovalForm && !showLogViewer">
    <div class="table-container" #tasksTableContainer id="tasks-table-container">
      <!-- Status Filter Dropdown -->
      <div class="filter-row">
        <input type="text" class="table-search-input" placeholder="Search" [(ngModel)]="searchText"
          (input)="onSearchInputChange()" />
      </div>
      <!-- End Status Filter Dropdown -->
      <table mat-table aria-describedby="tasks-details" matSort [dataSource]="filteredTasksDataSource"
        *ngIf="filteredTasksDataSource && filteredTasksDataSource.length > 0; else noTasks">

        <ng-container matColumnDef="title">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.TITLE' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            {{ task.title }}
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.DESCRIPTION' | translate }}
          </th>
          <td mat-cell *matCellDef="let task" class="description-cell" [matTooltip]="task.description"
            matTooltipClass="description-tooltip">
            {{ task.description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="taskType">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.TYPE' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            {{ task.taskType | titlecase }}
          </td>
        </ng-container>

        <ng-container matColumnDef="purpose">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.PURPOSE' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            {{ getTaskPurpose(task) | titlecase }}
          </td>
        </ng-container>

        <ng-container matColumnDef="branch">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.BRANCH' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            {{ getTaskBranch(task) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="assignedTo">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.ASSIGNED_TO' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            {{ getTaskAssignedTo(task) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="severity">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.SEVERITY' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            {{ task.severity | titlecase }}
          </td>
        </ng-container>

        <ng-container matColumnDef="plannedStartTime">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.PLANNED_START_TIME' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            {{ task.timing.plannedStartTime | date:'medium' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="plannedEndTime">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.PLANNED_END_TIME' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            {{ task.timing.plannedEndTime | date:'medium' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'TASK.STATUS' | translate }}
          </th>
          <td mat-cell class="status-col" *matCellDef="let task">
            {{ task.status }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th scope="col" mat-header-cell *matHeaderCellDef>
            {{ 'TASK.ACTIONS' | translate }}
          </th>
          <td mat-cell *matCellDef="let task">
            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="openContextMenu($event, task)">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="reviewTask(task)" [disabled]="task.status !== 'completed'">
                <mat-icon>check_circle</mat-icon>
                <span>{{ 'TASK.REVIEW' | translate }}</span>
              </button>
              <button mat-menu-item (click)="readTaskLog(task)">
                <mat-icon>description</mat-icon>
                <span>{{ 'TASK.READ_LOG' | translate }}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          [ngClass]="{'highlight': selectedTaskId == row._id}" (click)="highlightTask(row)">
        </tr>
      </table>

      <ng-template #noTasks>
        <div class="box-content-no-data">
          {{ 'TASK.NO_TASKS_FOUND' | translate }}
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Approval Form Section -->
  <div class="approval-form-section" *ngIf="showApprovalForm">
    <div class="section-header">
      <button mat-icon-button (click)="backToTable()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2>{{ 'TASK.APPROVE_TASK' | translate }}</h2>
    </div>

    <div class="task-details" *ngIf="selectedTaskForAction">
      <div class="task-info">
        <p><strong>{{ 'TASK.TITLE' | translate }}:</strong> {{ selectedTaskForAction.title }}</p>
        <p><strong>{{ 'TASK.DESCRIPTION' | translate }}:</strong> {{ selectedTaskForAction.description }}</p>
        <p><strong>{{ 'TASK.TYPE' | translate }}:</strong> {{ selectedTaskForAction.taskType }}</p>
        <p><strong>{{ 'TASK.PURPOSE' | translate }}:</strong> {{ getTaskPurpose(selectedTaskForAction) }}</p>
        <p><strong>{{ 'TASK.BRANCH' | translate }}:</strong> {{ getTaskBranch(selectedTaskForAction) }}</p>
        <p><strong>{{ 'TASK.ASSIGNED_TO' | translate }}:</strong> {{ getTaskAssignedTo(selectedTaskForAction) }}</p>
        <p><strong>{{ 'TASK.STATUS' | translate }}:</strong> {{ selectedTaskForAction.status }}</p>
        <p><strong>Planned Start Time:</strong> {{ selectedTaskForAction.timing.plannedStartTime | date:'medium' }}</p>
        <p><strong>{{ 'TASK.PLANNED_END_TIME' | translate }}:</strong> {{ selectedTaskForAction.timing.plannedEndTime |
          date:'medium' }}</p>
      </div>

      <div class="approval-form">
        <mat-form-field appearance="fill" class="full-width">
          <textarea matInput rows="4" placeholder="Add comments" [(ngModel)]="approvalComment"></textarea>
        </mat-form-field>

        <div class="approval-actions">
          <button mat-raised-button (click)="approve()">
            {{ 'TASK.APPROVE' | translate }}
          </button>
          <button mat-raised-button (click)="reject()">
            {{ 'TASK.REJECT' | translate }}
          </button>
          <button mat-stroked-button (click)="backToTable()">
            {{ 'TASK.CANCEL' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Approval Message Section -->
    <div class="status-message-section" *ngIf="statusMessage">
      <div class="status-message" [ngClass]="statusType">
        <i class="fa" [ngClass]="statusType === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
        {{ statusMessage }}
      </div>
    </div>
  </div>

  <!-- Log Viewer Section -->
  <div class="log-viewer-section" *ngIf="showLogViewer">
    <div class="section-header">
      <button mat-icon-button (click)="backToTable()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2>{{ 'TASK.TASK_LOG' | translate }}</h2>
    </div>

    <div class="task-details" *ngIf="selectedTaskForAction">
      <div class="log-content" *ngIf="taskLogs.length > 0">
        <div class="log-entry" *ngFor="let log of taskLogs">
          <div class="log-header">
            <div class="log-user-info">
              <span class="user-name">{{ log.user?.firstName }} {{ log.user?.lastName }} - {{ log.user?.role?.name |
                titlecase }}</span>
            </div>
            <div class="log-timestamp">{{ log.updatedAt | date:'medium' }}</div>
          </div>

          <div class="log-comment" *ngIf="log.comment">
            <strong>{{ 'TASK.COMMENT' | translate }}:</strong> {{ log.comment }}
          </div>

          <!-- Asset Usage Information -->
          <div class="log-asset-info" *ngIf="hasAssetUsages(log)">
            <div class="asset-details">
              <strong>{{ 'TASK.ASSET_DETAILS' | translate }}:</strong>
              <div class="asset-item">
                <span class="asset-label">Item:</span> {{ log.assetUsages.item?.name }}
              </div>
              <div class="asset-item" *ngIf="log.assetUsages.category">
                <span class="asset-label">{{ 'TASK.CATEGORY' | translate }}:</span> {{ log?.assetUsages?.category |
                titlecase }}
              </div>
              <div class="asset-item">
                <span class="asset-label">{{ 'TASK.TYPE' | translate }}:</span> {{ log.assetUsages.assetType | titlecase
                }}
              </div>
              <div class="asset-item">
                <span class="asset-label">{{ 'TASK.MODEL' | translate }}:</span> {{ log.assetUsages.assignedItem.model
                }}
              </div>
              <div class="asset-item" *ngIf="log.assetUsages.serial">
                <span class="asset-label">{{ 'TASK.SERIAL' | translate }}:</span> {{ log.assetUsages.serial }}
              </div>
              <div class="asset-item">
                <span class="asset-label">{{ 'TASK.MANUFACTURER' | translate }}:</span> {{
                log.assetUsages.assignedItem.manufacturer }}
              </div>
              <div class="asset-item">
                <span class="asset-label">{{ 'TASK.ACTION' | translate }}:</span> {{ log.assetUsages.taskAction |
                titlecase }}
              </div>
            </div>
          </div>

          <!-- Attachments -->
          <div class="log-attachments" *ngIf="log.attachmentUrl && log.attachmentUrl.length > 0">
            <strong>{{ 'TASK.ATTACHMENTS' | translate }}:</strong>
            <div class="attachment-item" *ngFor="let attachment of getAttachments(log.attachmentUrl)">
              <mat-icon>{{ getAttachmentInfo(attachment).icon }}</mat-icon>
              <span>{{ getAttachmentInfo(attachment).text }}</span>

              <!-- Audio Player for Audio Files -->
              <div class="audio-player" *ngIf="isAudioFile(attachment)">
                <audio controls>
                  <source [src]="attachment">
                </audio>
              </div>

              <!-- View Button for Non-Audio Files -->
              <button mat-icon-button *ngIf="attachment && attachment.trim() !== '' && !isAudioFile(attachment)"
                (click)="displayMedia(attachment)" class="attachment-button">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="no-logs-message" *ngIf="taskLogs.length === 0">
        <p>{{ 'TASK.NO_LOGS_YET' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Create Task Form -->
  <div class="task-content" *ngIf="!showTable && !showApprovalForm && !showLogViewer">
    <div class="dropdown-container">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'TASK.TASK_TYPE' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedTaskType" (selectionChange)="onTaskTypeChange($event.value)">
          <mat-option *ngFor="let taskType of taskTypes" [value]="taskType.value">
            {{ taskType.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width"
        *ngIf="selectedTaskType && getCurrentTaskTypePurposes().length > 0">
        <mat-label>{{ 'TASK.PURPOSE' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedPurpose" (selectionChange)="onPurposeChange($event.value)">
          <mat-option *ngFor="let purpose of getCurrentTaskTypePurposes()" [value]="purpose.value">
            {{ purpose.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'TASK.SEVERITY' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedSeverity" (selectionChange)="onSeverityChange($event.value)">
          <mat-option *ngFor="let severity of severities" [value]="severity.value">
            {{ severity.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'TASK.ASSIGNED_TO' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedUser" (selectionChange)="onUserChange($event.value)">
          <mat-optgroup *ngFor="let branch of branchesWithGuards" [label]="branch.branchName" class="branch-group">
            <mat-option *ngFor="let guard of branch.guards" [value]="guard.value">
              {{ guard.name }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Date Picker Section -->
    <div class="date-picker-section">
      <div class="date-inputs-row">
        <div class="date-input">
          <div class="label">{{ 'TASK.PLANNED_START_TIME' | translate }}</div>
          <div class="date-time-picker-div">
            <input [owlDateTimeTrigger]="startDateTime" class="date-time-picker" [owlDateTime]="startDateTime"
              [min]="currentDate" [(ngModel)]="plannedStartTime" [placeholder]="placeholder.selectDateAndTime"
              name="startDateTime" (ngModelChange)="onStartTimeChange($event)">
            <div class="calendar-icon" [owlDateTimeTrigger]="startDateTime">
              <i class="fas fa-calendar-alt"></i>
            </div>
            <owl-date-time #startDateTime [hour12Timer]="isHour12Format"></owl-date-time>
          </div>
        </div>

        <div class="date-input">
          <div class="label">{{ 'TASK.PLANNED_END_TIME' | translate }}</div>
          <div class="date-time-picker-div">
            <input [owlDateTimeTrigger]="endDateTime" class="date-time-picker" [owlDateTime]="endDateTime"
              [min]="plannedStartTime || currentDate" [(ngModel)]="plannedEndTime"
              [placeholder]="placeholder.selectDateAndTime" name="endDateTime"
              (ngModelChange)="onEndTimeChange($event)">
            <div class="calendar-icon" [owlDateTimeTrigger]="endDateTime">
              <i class="fas fa-calendar-alt"></i>
            </div>
            <owl-date-time #endDateTime [hour12Timer]="isHour12Format"></owl-date-time>
          </div>
        </div>
      </div>
    </div>

    <!-- Title and Description Section -->
    <div class="text-inputs-section">
      <div class="text-inputs-row">
        <div class="text-input">
          <div class="label">{{ 'TASK.TITLE' | translate }}</div>
          <input type="text" class="title-input" [(ngModel)]="taskTitle" [placeholder]="'Task title'" name="taskTitle"
            (ngModelChange)="onTitleChange($event)">
        </div>
      </div>
      <div class="text-inputs-row">
        <div class="text-input">
          <div class="label">{{ 'TASK.DESCRIPTION' | translate }}</div>
          <textarea class="description-textarea" [(ngModel)]="taskDescription" [placeholder]="'Task description'"
            name="taskDescription" rows="3" (ngModelChange)="onDescriptionChange($event)"></textarea>
        </div>
      </div>
    </div>

    <!-- Create Task Button Section -->
    <div class="create-button-section">
      <button class="btn btn-info" (click)="createTask()">
        {{ 'TASK.CREATE' | translate }}
      </button>
    </div>

    <!-- Status Message Section -->
    <div class="status-message-section" *ngIf="statusMessage">
      <div class="status-message" [ngClass]="statusType">
        <i class="fa" [ngClass]="statusType === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
        {{ statusMessage }}
      </div>
    </div>
  </div>
</div>